import { MetaObjectField } from '../types';

export const MASTER_QUERY = `
  query {
    metaobjects(type: "master", first: 1) {
      nodes {
        fields {
          key,
          value,
          type
        }
      }
    }
  }
`;

export type MasterQueryResponse = {
  metaobjects: {
    nodes: MasterMetaObjectNode[];
  };
};

type MasterMetaObjectNode = {
  fields: MetaObjectField[];
};
